module.exports = __webpack_public_path__ + "static/media/illustration_PIN_Kreis.5add24b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration_PIN_Kreis.svg
// module id = 728
// module chunks = 21